import { SET_AUTO_LOGOUT_MUTATION, SET_USER_DETAILS,SET_USER_TOKEN } from "@/store/storeconstants";

export default{
    [SET_USER_DETAILS](state,payload){
         state.userDetails=payload.userDetails;
         state.autoLogout=false;
    },
    [SET_USER_TOKEN](state,payload){
        state.token=payload.token;
   },
   [SET_AUTO_LOGOUT_MUTATION](state){
       state.autoLogout=true;
   }

};